import { render, staticRenderFns } from "./addScorePage.vue?vue&type=template&id=2bc671e4&scoped=true"
import script from "./addScorePage.vue?vue&type=script&lang=js"
export * from "./addScorePage.vue?vue&type=script&lang=js"
import style0 from "./addScorePage.vue?vue&type=style&index=0&id=2bc671e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc671e4",
  null
  
)

component.options.__file = "addScorePage.vue"
export default component.exports